"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Provider = require("./Provider");
Object.keys(_Provider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Provider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Provider[key];
    }
  });
});